#import "../fragments/user-quota-fragment.graphql"

mutation QuotaUpdate($input: QuotaUpdateInput!) {
    quotaUpdate(input: $input) {
        user {
            ...UserQuotaFragment
        }
    }
}
